module.exports = __webpack_public_path__ + "static/media/facebook.e12ff8f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/socialMedia/facebook.svg
// module id = 2315
// module chunks = 0